import { render } from "./App.vue?vue&type=template&id=3b7e1727"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3b7e1727&lang=css"

import exportComponent from "D:\\360极速浏览器X下载\\客户端\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__